module.exports = __webpack_public_path__ + "static/media/nft.5a7373ba.jpg";